// extracted by mini-css-extract-plugin
export default {"product-display":"ProductDisplay_product-display__U5hLE","product-name":"ProductDisplay_product-name__f9nFY","product-preview":"ProductDisplay_product-preview__c-v0k"};